module.exports = __webpack_public_path__ + "img/jingyingbang-zc.2eb21b2a.png";